import TwoCol from "components/blocks/TwoCol/TwoCol";
import MarkdownIt from "markdown-it";
import DOMPurify from "isomorphic-dompurify";

import ImageElement from "components/blocks/ImageElement/ImageElement";
import { convertStrapiAspectRatio } from "utils/image";

import styles from "./TwoColTextImage.module.scss";

export default function TwoColTextImage({ data }) {
  const {
    heading,
    heading_tag,
    text,
    image_position,
    image_type,
    images,
    slider,
    image_aspect_ratio,
  } = data;

  const aspectRatio = image_aspect_ratio
    ? convertStrapiAspectRatio(image_aspect_ratio)
    : null;

  let image = (
    <div className={`${styles.imageWrapper}`}>
      <ImageElement
        images={images}
        type={image_type}
        slider={slider ?? []}
        aspectRatio={aspectRatio}
      />
    </div>
  );

  const md = new MarkdownIt();
  const textElement = (
    <div
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(md.render(text)) }}
    />
  );

  return (
    <TwoCol
      title={heading}
      headingTag={heading_tag}
      column1Position={image_position}
      column1Content={textElement}
      column2Content={image}
    />
  );
}
